module.exports = __webpack_public_path__ + "static/media/waves_banner_gif.fb55b3ff.gif";